const GTM_SCRIPT_URL = "https://www.googletagmanager.com/gtm.js";

const loadedContainerIds = new Set();

// Odpowiednik oficjalnego snippetu GTM. Kontener oddziału dzieli dataLayer z głównym
// kontenerem GO-auto (GTM-5LQH9F2 w public/index.html) — tak Google zaleca przy wielu
// kontenerach na jednej stronie.
function init(containerId) {
    if (loadedContainerIds.has(containerId)) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({"gtm.start": new Date().getTime(), event: "gtm.js"});

    const script = document.createElement("script");
    script.async = true;
    script.src = GTM_SCRIPT_URL + "?id=" + encodeURIComponent(containerId);

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
    loadedContainerIds.add(containerId);
}

export default {
    init,
}
